import { render, staticRenderFns } from "./SitemapPage.vue?vue&type=template&id=bda3c494&scoped=true"
import script from "./SitemapPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SitemapPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SitemapPage.vue?vue&type=style&index=0&id=bda3c494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda3c494",
  null
  
)

export default component.exports